import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { query, collection, doc, setDoc, onSnapshot, Timestamp } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdClose } from "react-icons/md";
import Select_on_off from "../../components_root/select_on_off.jsx";

export default function Payment_data() {
    const servicetablename = "companies";
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [paymentstatus, setPaymentstatus] = useState(false);
    const [select_company_uid, setSelect_company_uid] = useState(null);
    const [guid, setGuid] = useState(null);
    const [sessiontoken, setSessiontoken] = useState(null);

    useEffect(() => {
        setGuid(Cookies.get("guid"));
        setSessiontoken(Cookies.get("sessiontoken"));
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    /* 🔹 LIVE PAYMENT STATUS */
    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "payment_setting")
        );

        const unsub = onSnapshot(q, (snap) => {
            if (!snap.empty) {
                setPaymentstatus(!!snap.docs[0].data().paymentstatus);
            }
        });

        return unsub;
    }, [select_company_uid]);

    /* 🔹 SAVE PAYMENT STATUS */
    const create_payment = async (newStatus) => {
        try {
            const paymentuid = "payment1";

            await setDoc(
                doc(db, servicetablename, select_company_uid, "payment_setting", paymentuid),
                {
                    paymentuid,
                    companyuid: select_company_uid,
                    guid,
                    sessiontoken,
                    paymentstatus: newStatus,
                    status: true,
                    date_time: Timestamp.now(),
                    date_time_update: Timestamp.now(),
                },
                { merge: true }
            );

            Toastshow("Payment setting updated");
        } catch (err) {
            console.error(err);
            Toastshow("Failed to update payment setting");
        }
    };

    /* 🔹 TOGGLE HANDLER */
    const handleToggle = () => {
        const newStatus = !paymentstatus;
        setPaymentstatus(newStatus);
        create_payment(newStatus);
    };

    return (
        <div>
            <Helmet>
                <title>Payment setting</title>
            </Helmet>

            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-h1 p-11 fcap">Payment setting</td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting?page=company")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="container_roots">
                <div className="container_size m-1">
                    <div className="post_div">
                        <div className="ui-grid">
                            <div className="ui-items p-1">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Payment online</td>
                                            <td width={70}>
                                                <Select_on_off
                                                    checked={paymentstatus}
                                                    onChange={handleToggle}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
